import { ApiResponse, handleApiCall } from './api';
import { InviteResponse } from 'src/interfaces/invite';

export async function createInvite(): Promise<ApiResponse<InviteResponse>> {
  return await handleApiCall<InviteResponse>('post', 'v2/invite');
}
